import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import AvatarUploaderEditor from './components/AvatarUploaderEditor';
import AvatarUploaderFileSelector from './components/AvatarUploaderFileSelector';

const AvatarUploader = props => {
  const {
    name,
    image,
    size,
    borderRadius,
    onChange,
    onRemove,
    onSelect,
    onBeforeSelect,
  } = props;

  const handleChange = obj => {
    onChange(name, obj);
  };

  const handleBeforeSelectImage = e => {
    onBeforeSelect &&
      typeof onBeforeSelect === 'function' &&
      onBeforeSelect(name, e);
  };

  const handleSelectImage = e => {
    const [file] = e.target.files;
    onSelect(name, {
      image: file,
      croppingRect: null,
      canvas: null,
    });
  };

  const handleRemove = () => {
    onRemove(name, {
      image: null,
      croppingRect: null,
      canvas: null,
    });
  };

  return image ? (
    <AvatarUploaderEditor
      image={image}
      size={size}
      borderRadius={borderRadius}
      onChange={handleChange}
      onRemove={handleRemove}
    />
  ) : (
    <AvatarUploaderFileSelector
      size={size}
      onChange={handleSelectImage}
      onBeforeChange={handleBeforeSelectImage}
    />
  );
};

AvatarUploader.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.object,
  size: PropTypes.number.isRequired,
  borderRadius: PropTypes.number,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onBeforeSelect: PropTypes.func,
};

export default AvatarUploader;
